<template>
    <defs>
        <!--== BARRIER PATHS ========================================================-->
        <path
            id="barrier-path-1"
            d="M 100,0
           A 100,100 0 0,1 0,100
           A 100,100 0 0,1 -100,0
           A 100,100 0 0,1 0,-100
           A 100,100 0 0,1 100,0
           z

           M 0,90
           A 90,90 0 0,0 90,0
           L 30,0
           A 30,30 0 0,1 0,30
           z

           M 0,-90
           A 90,90 0 0,0 -90,0
           L -30,0
           A 30,30 0 0,1 0,-30
           z"
        />

        <path
            id="barrier-path-2"
            d="M 100,0
           A 100,100 0 0,1  0,   100
           A 100,100 0 0,1 -100, 0
           A 100,100 0 0,1  0,  -100
           A 100,100 0 0,1  100, 0
           z

           M 80,0
           A 30,30 0 0,0  50,-30
           A 30,30 0 0,0  20, 0
           A 30,30 0 0,0  50, 30
           A 30,30 0 0,0  80, 0
           z


           M 5,-43.3
           A 30,30 0 0,0 -25, -73.3
           A 30,30 0 0,0 -55, -43.3
           A 30,30 0 0,0 -25, -13.3
           A 30,30 0 0,0  5,  -43.3
           z


           M 5,43.3
           A 30,30 0 0,0 -25, 13.3
           A 30,30 0 0,0 -55, 43.3
           A 30,30 0 0,0 -25, 73.3
           A 30,30 0 0,0  5,  43.3
           z"
        />

        <path
            id="barrier-path-3"
            d="M 100,0
           A 100,100 0 0,1  0,   100
           A 100,100 0 0,1 -100, 0
           A 100,100 0 0,1  0,  -100
           A 100,100 0 0,1  100, 0
           z

           M 0,90
           A 90,90 0 0,0 90,0
           L 30,0
           A 30,30 0 0,0  0, -30
           A 30,30 0 0,0 -30, 0
           A 30,30 0 0,0  0,  30
           z"
        />

        <path
            id="barrier-path-4"
            d="M 100,0
           A 100,100 0 0,1  0,   100
           A 100,100 0 0,1 -100, 0
           A 100,100 0 0,1  0,  -100
           A 100,100 0 0,1  100, 0
           z

           M -30.78,84.57
           A 90,90 0 0,0 90,0
           L 30,0
           A 30,30 0 0,1 -10.26,28.19
           z"
        />

        <path
            id="barrier-path-5"
            d="M 100,0
           A 100,100 0 0,1  0,   100
           A 100,100 0 0,1 -100, 0
           A 100,100 0 0,1  0,  -100
           A 100,100 0 0,1  100, 0
           z

           M 45,77.94
           A 90,90 0 0,0 45,-77.94
           L 45,-45
           A 58,58 0 0,0 45,45
           z

           M -45,-77.94
           A 90,90 0 0,0 -45,77.94
           L -45,45
           A 58,58 0 0,0 -45,-45
           z"
        />

        <path
            id="barrier-path-6"
            d="M 100,0
           A 100,100 0 0,1  0,   100
           A 100,100 0 0,1 -100, 0
           A 100,100 0 0,1  0,  -100
           A 100,100 0 0,1  100, 0
           z

           M  80, 25
           L  80,-25
           L -80,-25
           L -80, 25
           z"
        />

        <path
            id="barrier-path-blank"
            d="M 100,0
           A 100,100 0 0,1  0,   100
           A 100,100 0 0,1 -100, 0
           A 100,100 0 0,1  0,  -100
           A 100,100 0 0,1  100, 0
           z

           M 90,0
           A 90,90 0 0,0  0, -90
           A 90,90 0 0,0 -90, 0
           A 90,90 0 0,0  0,  90
           A 90,90 0 0,0  90, 0
           z"
        />

        <path
            id="barrier-path-finish"
            d="M 100,0
           A 100,100 0 0,1  0,   100
           A 100,100 0 0,1 -100, 0
           A 100,100 0 0,1  0,  -100
           A 100,100 0 0,1  100, 0
           z

           M 90,0
           A 90,90 0 0,0  -63.63,  -63.63
           L -53.03,-53.03
           A 75,75 0 0,0  -75,0
           L -90,0
           A 90,90 0 0,0  63.63,63.63
           L 53.03,53.03
           A 75,75 0 0,0  75,0
           z"
        />

        <!-- Collision Detection -->
        <line id="collision-line" x1="-300" y1="100" x2="100" y2="100" />
    </defs>
</template>

<script>
export default {
    name: 'BarrierComponent'
};
</script>
